import {
    Box,
    Heading,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeFontVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { SafeHTML } from "components/safe-html";

interface TextRowProps {
    title: string;
    comment?: string;
}
const TextRow = ({ title, comment }: TextRowProps) => {
    return (
        <Box mb={ThemeSpaceVariable.Medium} px={ThemeSpaceVariable.Medium}>
            <Heading
                as="h6"
                color={ThemeColorVariable.OnBackgroundHeader}
                fontSize={ThemeFontSizeVariable.Large}
                fontWeight="500"
                mb={ThemeSpaceVariable.XSmall}
            >
                <SafeHTML html={title} />
            </Heading>
            {comment && (
                <Text
                    fontFamily={ThemeFontVariable.SubHeader}
                    fontSize={ThemeFontSizeVariable.Medium}
                    color={ThemeColorVariable.OnBackgroundSubdued}
                >
                    <SafeHTML html={comment} />
                </Text>
            )}
        </Box>
    );
};

export default TextRow;
